import { Link } from '@tanstack/react-router'
import { Download, Film, ImageIcon, Scissors } from 'lucide-react'
import { PageHeader } from '@/components/ds/PageHeader'
import { Section } from '@/components/ds/Section'
import styles from './ToolsIndexPage.module.scss'

interface ToolEntry {
  to: string
  title: string
  description: string
  icon: typeof ImageIcon
  badge?: string
  /** Restricts the tool to a single platform — surfaces a small chip
   * on the card so the user understands why a TikTok-only flow won't
   * find this tool useful. ``undefined`` = platform-agnostic. */
  platform?: 'youtube' | 'tiktok'
}

const TOOLS: ToolEntry[] = [
  {
    to: '/tools/image-generation',
    title: 'Geração de imagem',
    description: 'Gere imagens a partir de um prompt usando Pollinations.ai ou Hugging Face (FLUX.1-schnell).',
    icon: ImageIcon,
    badge: 'POC',
  },
  {
    to: '/tools/background-removal',
    title: 'Remoção de fundo',
    description: 'Envie uma imagem — detecta o objeto principal, remove o fundo e devolve um PNG transparente.',
    icon: Scissors,
    badge: 'Novo',
  },
  {
    to: '/tools/youtube-download',
    title: 'Baixador de vídeo do YouTube',
    description: 'Cole a URL de um vídeo do YouTube — baixa em MP4 (melhor qualidade) e você salva direto no computador.',
    icon: Download,
    badge: 'Novo',
    platform: 'youtube',
  },
  {
    to: '/tools/clip-creator',
    title: 'Criador de clipes',
    description: 'Importe um vídeo (upload ou YouTube), marque os trechos na linha do tempo e organize cada corte separadamente.',
    icon: Film,
    badge: 'Novo',
  },
]

export function ToolsIndexPage() {
  return (
    <div className={styles.page}>
      <PageHeader
        title="Tools"
        description="Ferramentas auxiliares — utilidades pontuais que não pertencem a uma factory específica."
      />
      <Section>
        <div className={styles.grid}>
          {TOOLS.map((t) => {
            const Icon = t.icon
            return (
              // ``search: (prev) => prev`` keeps ``?channel=...`` (and anything
              // else the current route carries) on the URL — TanStack Router
              // otherwise replaces search with an empty object, which resets
              // the sidebar's active channel back to the default.
              <Link
                key={t.to}
                to={t.to}
                search={(prev) => prev}
                className={styles.card}
              >
                <div className={styles.cardHead}>
                  <Icon className={styles.cardIcon} aria-hidden />
                  <div className={styles.badgeRow}>
                    {t.platform ? (
                      <span className={styles.platformBadge} title={`Específico de ${t.platform === 'youtube' ? 'YouTube' : 'TikTok'}`}>
                        {t.platform === 'youtube' ? 'YouTube' : 'TikTok'} only
                      </span>
                    ) : null}
                    {t.badge ? <span className={styles.badge}>{t.badge}</span> : null}
                  </div>
                </div>
                <h3 className={styles.cardTitle}>{t.title}</h3>
                <p className={styles.cardDesc}>{t.description}</p>
              </Link>
            )
          })}
        </div>
      </Section>
    </div>
  )
}
